import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { CommunityDto, LgaDto } from '@cradua/data';
import { NotificationService, ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-community-container',
  templateUrl: './community-container.component.html',
  styleUrls: ['./community-container.component.scss'],
})
export class CommunityContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  lgas$: Observable<LgaDto[]>;
  communities$: Observable<CommunityDto[]>;
  loading: boolean;
  isLoadingLga$: Observable<boolean>;
  isLoadingCommunity$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoadingLga$ = this.gatwayFacade.isLoadingGateway('Lga');
    this.isLoadingCommunity$ = this.gatwayFacade.isLoadingGateway(
      'Communities'
    );

    this.lgas$ = this.gatwayFacade.loadGateway('Lga');
    this.communities$ = this.gatwayFacade.loadGateway('Communities');
  }

  /**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteCommunity(deletedValue: any) {
    this.gatwayFacade.remove('Communities', deletedValue);
  }

  // this method control both the create and update
  onSubmitCommunity(formValue: any) {
    const pullData = formValue.Communities;

    // declare two empty array to hold update and create data
    const allUpdates = [];
    const addAllCommunity = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id) {
        allUpdates.push(pullData[i]);
      } else {
        addAllCommunity.push(pullData[i]);
      }
    }

    // check if the addAllCommunity array is not empty, then dispatch the data to the store
    if (addAllCommunity.length > 0) {
      this.gatwayFacade.add('Communities', addAllCommunity);
    }

    // dispatch update data to the store
    if (allUpdates.length > 0) {
      this.gatwayFacade.update('Communities', allUpdates, ['id']);
    }
  }
}
